export default "__VITE_ASSET__SYtOrLWo__"